import React, { useEffect, useContext } from 'react'

import { useRouter } from 'next/router'
import { css } from '@emotion/core'
import { useQuery } from '@apollo/react-hooks'
import { GET_KAMPUSPEDIA_POPULAR_LIST, GET_KAMPUSPEDIA_INDEX } from '@graphql/queries/kampuspedia'
import { PageCtx, ActionType, SearchCategory } from 'components/utils/PageProvider'

import Breadcrumb from 'components/common/molecules/Breadcrumb'
import AlphabetMenu from 'components/common/molecules/AlphabetMenu'
import Container from 'components/layouts/atoms/Container'

import KampuspediaHeader from './KampuspediaHeader'
import KampuspediaSeoText from './KampuspediaSeoText'
import KampuspediaIndex from './KampuspediaIndex'
import KampuspediaPopTerms from './KampuspediaPopTerms'
import KampuspediaProvider, {
  IndexList,
  KampuspediaCtx,
  ActionType as ActionTypeKampuspedia,
  KampuspediaStatus,
} from 'components/utils/KampuspediaProvider'

const kampuspediaLPBgStyle = css`
  background-image: url('/next-assets/images/kampuspedia/rectangle-sp.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;
  @media screen and (min-width: 768px) {
    background-image: url('/next-assets/images/kampuspedia/banner-pc.png'),
      url('/next-assets/images/kampuspedia/rectangle-pc.png');
    background-size: 100%;
  }
`

const KampuspediaLP = () => {
  const { dispatch } = useContext(PageCtx)
  useEffect(() => {
    dispatch({
      type: ActionType.SET_CUSTOM_NAVBAR,
      payload: {},
    })
    dispatch({
      type: ActionType.SET_SEARCH_CATEGORY,
      payload: SearchCategory.kampuspedia,
    })
  }, [])

  const kampuspediaPath = [
    {
      name: 'Kampuspedia',
      url: '#',
    },
  ]
  const { data: popTermsData } = useQuery(GET_KAMPUSPEDIA_POPULAR_LIST)
  const popTerms = popTermsData?.kampuspediaPopularList

  const { data: indexData } = useQuery(GET_KAMPUSPEDIA_INDEX)
  const { state, setIndexList, dispatch: dispatchKampuspedia } = useContext(KampuspediaCtx)

  useEffect(() => {
    if (indexData) {
      setIndexList(indexData?.kampuspediaIndex[0], indexData?.kampuspediaIndex)
    } else {
      dispatchKampuspedia({ type: ActionTypeKampuspedia.SET_PENDING })
    }
    if (state.activeIndex !== state.indexList.indexDetailList.index) {
      const newData = state.allIndex.find((item: IndexList) => state.activeIndex === item.indexDetailList.index)
      newData && setIndexList(newData)
    }
  }, [indexData, state.activeIndex])

  const router = useRouter()
  const stickyProps = {
    indexClassName: '.kampuspedia-index__wrapper',
    startStickyClassName: '.kampuspedia-lp__wrapper',
    stopStickyClassName: '.kampuspedia-seo-text',
    infiniteScroll: false,
  }

  return (
    <div className="kampuspedia-lp">
      <div className="kampuspedia-lp__wrapper" css={kampuspediaLPBgStyle}>
        <Breadcrumb paths={kampuspediaPath} background="transparent" hideOnMobile />

        <KampuspediaHeader />

        <Container isMobileFull>
          <KampuspediaPopTerms popTerms={popTerms} />
          <AlphabetMenu
            loading={state.status !== KampuspediaStatus.completed}
            activeAlphabet={state.activeIndex}
            onClick={(index: string) =>
              dispatchKampuspedia({ type: ActionTypeKampuspedia.SET_ACTIVE_INDEX, payload: index })
            }
            disabledIndex={state.disabledIndex}
            kind="index"
            stickyProps={stickyProps}
          />
        </Container>
      </div>

      <KampuspediaIndex />

      <KampuspediaSeoText>
        <AlphabetMenu
          loading={state.status !== KampuspediaStatus.completed}
          activeAlphabet={state.activeIndex}
          url="/kampuspedia/group/"
          onClick={(index: string) => router.push(`/kampuspedia/group/${encodeURIComponent(index.toLowerCase())}`)}
          disabledIndex={state.disabledIndex}
        />
      </KampuspediaSeoText>
    </div>
  )
}

export { KampuspediaLP }

const KampuspediaLPWithProvider = () => (
  <KampuspediaProvider>
    <KampuspediaLP />
  </KampuspediaProvider>
)

export default KampuspediaLPWithProvider
